// Автоопределение языка вопроса в режиме «Спроси Turkido» (tutor-qa.tsx).
// Раньше язык голосового вопроса выбирался вручную кнопкой RU/TR
// (components/voice-lang-toggle.tsx, удалена): Web Speech API распознаёт
// ровно один язык за сеанс, и выбрать его нужно ДО начала записи, когда речи
// ещё нет и определять нечего. Поэтому язык берём из того, что уже известно:
// набранный в поле текст → язык прошлого вопроса в этой сессии → русский по
// умолчанию (большинство мета-вопросов о языке задают именно на нём).

export type VoiceLang = 'ru-RU' | 'tr-TR'

const CYRILLIC = /[\u0400-\u04FF]/g
// Латиница вместе с турецкими буквами с диакритикой — ı/İ в юникоде лежат
// вне ASCII-диапазона, без них слова вроде «yaptım» считались бы наполовину.
const LATIN = /[A-Za-zÇçĞğİıÖöŞşÜü]/g

// null — определить нельзя: пусто, только цифры/пунктуация или букв обоих
// алфавитов поровну. Считаем буквы, а не «есть ли хоть одна»: вопросы почти
// всегда смешанные («когда использовать -mış?»), и решать должен тот алфавит,
// на котором написана основная часть фразы.
export function detectLang(text: string): VoiceLang | null {
  const cyrillic = text.match(CYRILLIC)?.length ?? 0
  const latin = text.match(LATIN)?.length ?? 0
  if (cyrillic === latin) return null
  return cyrillic > latin ? 'ru-RU' : 'tr-TR'
}

// Язык для очередной записи с микрофона. lastUsed — язык последнего вопроса
// этой сессии: спрашивают голосом обычно с пустым полем, и единственная
// зацепка — на чём говорили в прошлый раз.
export function pickVoiceLang(typed: string, lastUsed: VoiceLang | null): VoiceLang {
  return detectLang(typed) ?? lastUsed ?? 'ru-RU'
}

export function langLabel(lang: VoiceLang): string {
  return lang === 'ru-RU' ? 'русский' : 'турецкий'
}
